import {
  TOGGLE_BENEFIT,
  SET_SELECTED_BENEFITS,
} from '../actions/taxBenefits';

export default function benefits(state = [], action) {
  Object.freeze(state);

  switch (action.type) {
    case TOGGLE_BENEFIT:
      return state.indexOf(action.benefit) === -1
        ? [...state, action.benefit]
        : state.filter(benefit => benefit !== action.benefit);
    case SET_SELECTED_BENEFITS:
      return action.benefits;
    default:
      return state;
  }
}
